// extracted by mini-css-extract-plugin
export default {"col":"index_col_SiMLY clearfix","col_R":"index_col_R_JX047"};